export const COLUMN_SIGNALS_NAME = "signals_array";

export const COLUMN_NEWS_NAME = "company_news_titles";

export const COLUMN_AD_NETWORKS_ADDED_NAME = "addedAdNetworks";

export const COLUMN_AD_NETWORKS_REMOVED_NAME = "removedAdNetworks";

export const COLUMN_TECHNOLOGIES_ADDED_NAME = "addedTechnologies";

export const COLUMN_TECHNOLOGIES_REMOVED_NAME = "removedTechnologies";

export const COLUMN_TECHNOLOGIES_WITH_POTENTIAL_RENEWAL = "technologiesWithPotentialRenewal";

export const COLUMN_TRAFFIC_COUNTRIES_NAME = "traffic_countries";

export const COLUMN_ECOMMERCE_SIGNAL_DATA = "ecommerce_signal_data";

export const COLUMN_INTENT_SIGNAL_NAME = "intent_topic_scopes";
